import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Globe } from "lucide-react";
import { useSite } from "../../context/SiteContext";

const LINKS = [
  ["#top", "Anasayfa"],
  ["#paketler", "Fiyatlar"],
  ["#kurulum", "Kurulum"],
  ["#iletisim", "İletişim"],
];

export default function Nav({ go, ticker }) {
  const { trial, webPanel: WEB_PANEL } = useSite();
  const [open, setOpen] = useState(false);
  const click = (e, h) => { e.preventDefault(); setOpen(false); go(h); };

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50"
    >
      {ticker}
      <div className="mx-4 md:mx-8 mt-3 flex items-center justify-between rounded-full border border-white/10 bg-[#0d0b3d]/70 backdrop-blur-xl px-4 md:px-6 py-2.5">
        <a href="#top" onClick={(e) => click(e, "#top")} data-testid="nav-logo">
          <img src="/img/logo-t.png" alt="Dolunay TV" className="h-10 md:h-12 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-2">
          {LINKS.map(([h, l]) => (
            <a key={h} href={h} onClick={(e) => click(e, h)} data-testid={`nav-link-${h.slice(1)}`}
              className="rounded-full px-6 py-3 text-base font-semibold text-[#c9c6f0] hover:text-white hover:bg-white/10 transition-colors">{l}</a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={WEB_PANEL} target="_blank" rel="noreferrer" data-testid="nav-web-login-btn"
            className="hidden md:inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-3 text-base font-semibold text-white hover:bg-white/10 transition-colors">
            <Globe size={17} /> Web Giriş
          </a>
          <a href={trial} target="_blank" rel="noreferrer" data-testid="nav-trial-btn"
            className="hidden sm:inline-flex rounded-full bg-white text-[#0d0b3d] px-6 py-3 text-base font-semibold hover:bg-[#8a8dff] hover:text-white transition-colors">
            Ücretsiz Test
          </a>
          <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-white" data-testid="nav-menu-toggle" aria-label="Menü">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
            className="lg:hidden mx-4 mt-2 rounded-3xl border border-white/10 bg-[#0d0b3d]/95 backdrop-blur-xl p-6 flex flex-col gap-4" data-testid="mobile-menu">
            {LINKS.map(([h, l]) => (
              <a key={h} href={h} onClick={(e) => click(e, h)} className="font-display text-xl text-white" data-testid={`mobile-link-${h.slice(1)}`}>{l}</a>
            ))}
            <a href={WEB_PANEL} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center justify-center gap-2 rounded-full border border-white/20 px-5 py-3 font-semibold text-white" data-testid="mobile-web-login-btn">
              <Globe size={17} /> Web'den Giriş Yap
            </a>
            <a href={trial} target="_blank" rel="noreferrer" className="rounded-full bg-white text-[#0d0b3d] px-5 py-3 text-center font-semibold" data-testid="mobile-trial-btn">
              6 Saat Ücretsiz Test
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
